// extracted by mini-css-extract-plugin
module.exports = {"Separator":"Separator-2LRr2","Line":"Line-1YytL"};